import { bootstrapApplication } from "@angular/platform-browser";

import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

bootstrapApplication(AppComponent, appConfig)
.catch((error: unknown) => {
  // Nothing above this point can report a failure, so the console is the only
  // channel left. A bootstrap failure here is almost always a bad tenant
  // config — a wrong Auth0 client id or an unreachable branding endpoint.
  console.error("customer-portal failed to bootstrap", error);
});
